<template>
    <div :style="{marginTop: init_item.marginTop ? init_item.marginTop :marginTop,marginBottom:init_item.marginBottom?init_item.marginBottom:marginBottom}"
        style="width: 100%" v-show="(init_item.show?init_item.show:show) || (init_item.page_size?init_item.page_size:page_size)<(init_item.total?init_item.total:total)">
        <el-pagination
                :style="{float:init_item.float?init_item.float:float}"
                :small="init_item.small?init_item.small:small"
                :background="init_item.background?init_item.background:background"
                :page-size="init_item.page_size?init_item.page_size:page_size"
                :total="init_item.total?init_item.total:total"
                :pager-count="init_item.pager_count?init_item.pager_count:pager_count"
                :layout="init_item.layout?init_item.layout:layout"
                :page-sizes="init_item.pageSizes?init_item.pageSizes:pageSizes"
                :disabled="init_item.disabled?init_item.disabled:disabled"
                :current-page="init_item.currentPage?init_item.currentPage:currentPage"
                @current-change="currentChange"
        >
        </el-pagination>
    </div>
</template>

<script>
export default {
  name: 'PageComponent',
  props: ['init_item'],
  data() {
    return {
      // 样式
      marginTop: '10px',
      marginBottom: '10px',
      float: 'right',
      // 参数
      small: false,
      background: true,
      page_size: 10,
      total: 0,
      pager_count: 5,
      layout: 'prev, pager, next',
      pageSizes: [10, 20, 30, 40, 50, 100],
      disabled: false,
      show: false,
      currentPage: 1
    }
  },
  methods: {
    currentChange(currentPage) {
      this.$emit('currentPage', currentPage)
    }
  }
}
</script>

<style scoped>

</style>
